var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#169b62",
    d: "M0 0h1200v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M400 0h800v600H400z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff883e",
    d: "M800 0h400v600H800z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIe);
export default __webpack_public_path__ + "static/media/ie.fed6e4f7d3267ace675345b4ea6a3b18.svg";
export { ForwardRef as ReactComponent };